import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withQueryResults from 'components/shared/withQueryResults'
import withWaiverForms from 'components/shared/withWaiverForms'
import withQuery from './withQuery'

// presentational component
import UI from './UI'

export default compose(
  withRedux,
  withQueryResults, // for handling query errors
  withWaiverForms,
  withQuery // for fetching account data
)(UI)
